export default "__VITE_ASSET__D6G6HSYI__"